import { createAction, handleActions } from 'redux-actions';
import { toastr } from 'react-redux-toastr';
import * as Sentry from '@sentry/browser';

export const setUser = createAction('SET_USER');
export const setIsAdminMimicing = createAction('SET_ADMIN_MIMICING');
export const setUnauthorizedStatus = createAction('SET_UNAUTH_USER');
export const setSupervisorOrgStatus = createAction('SET_SUPERVISOR_ORG_STATUS');
export const setErrorStatus = createAction('SET_ERROR_STATUS');

const initialState = {
	activated: true,
	address: '',
	address2: '',
	admin: false,
	alt_phone: '',
	city: '',
	email: '',
	first_name: '',
	id: 0,
	is_admin_mimicing: false,
	is_error_occured: false,
	is_registration_completed: false,
	is_registration_reviewed: false,
	is_unathorised: false,
	last_name: '',
	nurse: false,
	organization_id: 0,
	phone: '',
	profile_photo: '',
	push_notify: true,
	push_token: '',
	RegistrationCompleted: false,
	RegistrationReviewed: false,
	reject_reason: null,
	reset_password: false,
	role: '',
	role_id: 0,
	state: '',
	supervisor: false,
	supervisorOrgStatus: 0,
	suspended: false,
	token: '',
	user_orgs: [],
	xxx: '',
	zip: ''
};

export default handleActions(
	{
		SET_ADMIN_MIMICING: (state, action) => ({ is_admin_mimicing: action.payload }),
		SET_ERROR_STATUS: (state, action) => ({ ...state, is_error_occured: action.payload }),
		SET_SUPERVISOR_ORG_STATUS: (state, action) => ({ ...state, supervisorOrgStatus: action.payload }),
		SET_UNAUTH_USER: (state, action) => ({ ...state, is_unathorised: action.payload }),
		SET_USER: (state, action) => ({ ...state, ...action.payload, address2: action.payload.additional_address })
	},
	initialState
);

export const getToastrOptions = () => {
	const options = {};
	options.icon = (
		<div style={{ paddingTop: '5px' }}>
			<img src={require('../assets/img/errorImg.png')} />
		</div>
	);
	options.showCloseButton = false;
	return options;
};

export const handleError = (response) =>
	function (dispatch) {
		if (response && !response.ok) {
			if (response.status === 401) {
				dispatch(setUnauthorizedStatus(true));
			} else if (response.status === 403) {
				dispatch(setErrorStatus(true));
				toastr.error('Forbidden', response.data?.message, getToastrOptions());
			} else if (response.status === 409) {
				dispatch(setErrorStatus(true));
				const options = getToastrOptions();
				options.timeOut = 10000;
				toastr.warning('Attention!', response.data, options);
			} else {
				dispatch(setErrorStatus(true));
				toastr.error(
					'Error!',
					'Oops, something went wrong! Our apologies. Please try again in a moment or contact us at 617-944-1515. Thank you.',
					getToastrOptions()
				);
				if (process.env.APPENV === 'prod') {
					Sentry.withScope((scope) => {
						scope.setTags({ error_type: 'api-error' });
						Sentry.captureEvent({
							message: {
								'api-url': response.config.url,
								message: 'Something went wrong',
								params: [response.config.params],
								'response-object': JSON.stringify(response)
							}
						});
					});
				}
			}
		}
	};
